export default __webpack_public_path__ + "static/media/12-2.d4da2b5f.png";